import { useState, useRef, useEffect, KeyboardEvent } from "react";

export interface ISearchTextManager {
    clear(): void;
    focus(): void;
}

interface ISearchTextProps {
    onChanged: (value: string) => void;
    placeholder?: string;
    manager?: (value: ISearchTextManager) => void;
}


export default function SearchText(props: ISearchTextProps) {

    const [value, setValue] = useState("");
    let lastText = value;
    const inputEl = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (props.manager) {
            const manager: ISearchTextManager = {
                clear: () => inputEl.current.value = "",
                focus: () => inputEl.current.focus()
            };
            props.manager(manager);
        }
    });

    const pool = (el: HTMLInputElement) => {

        if (el.value != lastText) {
            lastText = el.value;
            setValue(lastText);
            props.onChanged(lastText);
        }

        if (document.activeElement == el)
            setTimeout(() => pool(el), 300);
    }

    const onKeyDown = (ev: KeyboardEvent<HTMLInputElement>) => {
        if (ev.keyCode === 13) {
            lastText = ev.currentTarget.value;
            setValue(lastText);
            props.onChanged(lastText);
            ev.currentTarget.blur();
        }
    }

    return (
        <input value={value} onChange={ev=> setValue(ev.currentTarget.value)} onKeyDown={onKeyDown} ref={inputEl} placeholder={props.placeholder} type="text" onFocus={ev => pool(ev.currentTarget)} />
    );
}
